import axios from 'axios'
import CONFIG from '../config.js'

import takeFirstResult from '@/api/util/takeFirstResult'
import flattenACF from '@/api/util/flattenACF'
import normalizeWordpress from '@/api/util/normalizeWordpress'
import transformService from '@/api/util/transformService'
import transformFlexContent from '@/api/util/transformFlexContent'
import transformLocalizationInfo from '@/api/util/transformLocalizationInfo'
import transformPostMeta from '@/api/util/transformPostMeta'

export function getServicesList (lang = 'de-ch') {
	return axios.get(`${CONFIG.API_URL}/wp/v2/service?per_page=100${lang === 'en-us' ? '&lang=en' : '&lang=de'}`, {
		transformResponse: [].concat(
			axios.defaults.transformResponse,
			normalizeWordpress,
			flattenACF,
			transformLocalizationInfo,
			transformPostMeta,
			transformService
		)
	}).then((response) => {
		// console.log('getServicesList', response.data)
		return response
	})
}

export function getServiceOverviewPage ({ lang = 'de-ch', slug = 'service' }) {
	return new Promise((resolve, reject) => {
		return axios.get(`${CONFIG.API_URL}/wp/v2/pages?slug=${slug}${lang === 'en-us' ? '&lang=en' : '&lang=de'}`, {
			transformResponse: [].concat(
				axios.defaults.transformResponse,
				takeFirstResult,
				normalizeWordpress,
				flattenACF,
				transformLocalizationInfo,
				transformPostMeta
			)
		})
		.then(response => {
			// console.log('getServiceOverviewPage', response.data)
			const { data } = response
			;(data && data.id) ? resolve(data) : reject({ status: 404, statusMessage: 'Not found' })
		})
		.catch(response => reject(response))
	})
}

export function getServiceBySlug ({ lang = 'de-ch', slug = '' }) {
	return new Promise((resolve, reject) => {
		axios.get(`${CONFIG.API_URL}/wp/v2/service?slug=${slug}&lang=${lang === 'en-us' ? 'en' : 'de'}`, {
			transformResponse: [].concat(
				axios.defaults.transformResponse,
				takeFirstResult,
				normalizeWordpress,
				flattenACF,
				transformService,
				transformPostMeta,
				transformFlexContent
			)
		})
		.then(response => {
			// console.log('getServiceBySlug', response.data)
			const { data } = response
			;(data && data.id) ? resolve(data) : reject({ status: 404, statusMessage: 'Not found' })
		})
		.catch(response => reject(response))
	})
}

export default 'yolo'



// WEBPACK FOOTER //
// ./src/api/services.wp.api.js